import i18next from 'i18next';

const { REACT_APP_OPERATOR } = process.env;

export const OPERATORS = {
	RETAIL: 'retail',
	VECTRA: 'vectra',
	MULTIMEDIA: 'multimedia',
	SGT: 'sgt',
	MULTIOPERATOR: 'multioperator',
	ELSAT: 'elsat',
	SATFILM: 'satfilm'
};

export const SYSTEM_OPERATOR = {
	pureott: OPERATORS.RETAIL,
	vectra: OPERATORS.VECTRA,
	MMPDTV: OPERATORS.MULTIMEDIA,
	SGT: OPERATORS.SGT,
	ofertaT4B1182: OPERATORS.ELSAT,
	SATFILM: OPERATORS.SATFILM
};

export const ALL_OPERATORS = Object.values(OPERATORS);
export const PACKETS_OPERATORS = [OPERATORS.VECTRA];

export const DVR_RECORDINGS_OPERATORS = [
	OPERATORS.VECTRA,
	OPERATORS.SGT,
	OPERATORS.MULTIMEDIA,
	OPERATORS.MULTIOPERATOR,
	OPERATORS.ELSAT,
	OPERATORS.SATFILM
];

export const REGULATION_OPERATORS = [
	OPERATORS.VECTRA,
	OPERATORS.SGT,
	OPERATORS.MULTIMEDIA,
	OPERATORS.ELSAT,
	OPERATORS.SATFILM
];

export const DOCUMENT_OPERATORS = [OPERATORS.RETAIL];

export const CONFIGURATOR_OPERATORS = [OPERATORS.RETAIL];

export const filterOperatorLinks = ({ operators }) =>
	operators.includes(REACT_APP_OPERATOR);

export const getOperatorContact = () => {
	switch (REACT_APP_OPERATOR) {
		case OPERATORS.RETAIL:
			return '/kontakt';
		default:
			return '/strona/kontakt';
	}
};

export const getCustomerAreaData = () => {
	const key = 'operators_customer_area';

	const caText = i18next.t(`${key}_text_${REACT_APP_OPERATOR}`);
	const caUrl = i18next.t(`${key}_url_${REACT_APP_OPERATOR}`);
	const caLogoAlt = i18next.t(`${key}_alt_${REACT_APP_OPERATOR}`);

	const caLogoUrl = i18next.t(`${key}_logo_url`, {
		operator: REACT_APP_OPERATOR
	});

	return { caText, caUrl, caLogoAlt, caLogoUrl };
};
